module.exports = __webpack_public_path__ + "static/media/assessmentViewPage.269c2a62.scss";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Assessments/assessmentViewPage.scss
// module id = 527
// module chunks = 0